"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
var _default = exports.default = {
  getList: function getList(data, cancelToken) {
    return (0, _request.default)({
      url: '/protected/push_msg/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  rePushBatchMsg: function rePushBatchMsg(data, cancelToken) {
    return (0, _request.default)({
      url: '/protected/push_msg/re_push_batch_msg',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  }
};